/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import {
    shape, string, arrayOf,
    number, object, func,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import { combineStyle } from '../../../style/combineStyle';
import { deepObjectExtend, isEmpty } from '../../../utils/object';
import { main as MainStyle } from '../../../style/main';
import { form as FormStyle } from '../../../style/form';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';
import { getFeatureFlags } from '../../../utils/featureSelectors';
import { DesktopAddressBookStyle } from '../../../style/DesktopAddressBookStyle';
import DesktopAddressList from './DesktopAddressList';
import DesktopAddressDetail from './DesktopAddressDetail';
import DesktopAddressForm from './DesktopAddressForm';
import DesktopAddressAddForm from './DesktopAddressAddForm';

const { PERSIST_KEY } = configENV;
const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
        FormStyle,
        DesktopAddressBookStyle,
    }),
);

const DesktopAddressBook = ({
    classes,
    addForm,
    recipients,
    handleDesktopAddNewRecipient,
    handleDesktopAddNewFormClicked,
    fetchUserProfile,
}) => {
    const [isAddNewAddressClicked, setIsAddNewAddressClicked] = useState(false);

    useEffect(() => {
        handleDesktopAddNewRecipient();
        fetchUserProfile();
    }, [handleDesktopAddNewRecipient, fetchUserProfile]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    }, []);

    const handleDesktopAddNewAddress = () => {
        setIsAddNewAddressClicked(true);
        handleDesktopAddNewFormClicked();
    };

    const handleDeleteAddress = () => {
        setIsAddNewAddressClicked(false);
    };

    const showForm = !isEmpty(recipients) || isAddNewAddressClicked;

    return (
        <>
            <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }} className={`container ${classes.DesktopAddressBookStyle}`}>
                <div className="position-relative">
                    <h2 className="float-left">Address Book</h2>
                </div>
                <Grid className="shadowContentGrid contentGrid" container item xs={12}>
                    <Grid item xs={showForm ? 5 : 12} className="display-flex column">
                        <DesktopAddressList />
                        <div className={`addNewAddressWrapper ${!showForm ? 'empty' : ''}`}>
                            <Button
                                className=""
                                onClick={() => handleDesktopAddNewAddress()}
                                aria-labelledby="add new address"
                            >
                                Add New Address
                            </Button>
                        </div>
                    </Grid>
                    <Grid item xs={7} className={`addressDetailsWrapper ${!showForm ? 'display-none' : ''}`}>
                        {
                            (addForm === 'AddForm') ? <DesktopAddressAddForm /> : null
                        }
                        {
                            (addForm === 'EditForm') ? <DesktopAddressForm handleDeleteAddress={handleDeleteAddress} /> : null
                        }
                        <DesktopAddressDetail addForm={addForm} />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

DesktopAddressBook.defaultProps = {
    handleDesktopAddNewRecipient: () => {},
    handleDesktopAddNewFormClicked: () => {},
    addForm: '',
    recipients: [],
};

DesktopAddressBook.propTypes = {
    classes: object.isRequired,
    handleDesktopAddNewRecipient: func,
    handleDesktopAddNewFormClicked: func,
    addForm: string,
    recipients: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            FirstName: string,
            LastName: string,
            RelationShip: string,
            NickName: string,
            LastUpdateDate: string,
            EmployerName: string,
            NumberOfAddresses: number,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    ContactId: number,
                }),
            ),
        }),
    ),
    fetchUserProfile: func.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
        // eslint-disable-next-line no-empty
        } catch (ex) {}
    }
    return {
        addFormLable: newState.addFormLable,
        addForm: newState.addForm,
        recipients: newState.recipients,
        featureFlags,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
    handleDesktopAddNewRecipient: () => dispatch(EventDispatcher.handleDesktopAddNewRecipient()),
    handleDesktopAddNewFormClicked: () => dispatch(EventDispatcher.handleDesktopAddNewFormClicked('RecipientForm')),
    // handleCloseDialog: () => dispatch(EventDispatcher.handleCloseDialog()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopAddressBook)));
